import React, { useState, useEffect, Fragment } from 'react'
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  IconButton,
  List,
  ListItem,
  Menu,
  Tooltip,
  Typography,
  Card,
  Collapse,
  CardContent,
} from '@mui/material'
import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'
import { useDropzone } from 'react-dropzone'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone'
import CheckIcon from '@mui/icons-material/Check'
import CameraAltTwoToneIcon from '@mui/icons-material/CameraAltTwoTone'
import EditIcon from '@mui/icons-material/Edit'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ImageCropper from '@/housefolios-components/Dialogs/ImageCropper'
// Centralized lodash imports - much cleaner!
import {
  compact,
  get,
  isEmpty,
  map,
  cloneDeep,
  set,
} from '@/utils/lodash'
import { IMAGE_UPLOAD } from '@/housefolios-components/TitleButtons/AddPropertyButton/mutations'
import { useMutation } from '@apollo/client/react'
import clsx from 'clsx'

const HardMoneyLenderQuestions = ({
  open,
  onClose,
  onSave,
  contact,
}) => {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    name: '',
    types: [],
    email: '',
    phone: '',
    company: '',
    notes: '',
    ranking: 3,
    optionalFields: {},
  })

  useEffect(() => {
    if (contact) {
      setFormData({
        name: contact.name || '',
        types: contact.types || [],
        email: contact.email || '',
        phone: contact.phone || '',
        company: contact.company || '',
        notes: contact.notes || '',
        ranking: contact.ranking || 3,
        optionalFields: contact.optionalFields || {},
      })
    } else {
      setFormData({
        name: '',
        types: [],
        email: '',
        phone: '',
        company: '',
        notes: '',
        ranking: 3,
        optionalFields: {},
      })
    }
  }, [contact])

  const handleChange = (event) => {
    const { name, value } = event.target
    const newData = cloneDeep(formData)
    set(newData, name, value)
    setFormData(newData)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    setLoading(true)
    try {
      await onSave(formData)
      onClose()
    } catch (error) {
      console.error('Error saving contact:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <BlockUi
        blocking={loading}
        loader={
          <PacmanLoader color={'var(--primary)'} loading={true} />
        }
        message={
          <Box sx={{ color: '#368cff' }}>
            {contact ? 'Updating Contact' : 'Adding Contact'}
          </Box>
        }
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>
            {contact ? 'Edit Contact' : 'Add New Contact'}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              {/* Hard Money Lender Details (non-questionnaire) */}
              <Grid size={12}>
                <Typography sx={{ mt: 2, fontWeight: 600 }}>
                  Hard Money Lender Details
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.percentLoan"
                  label="What Percent do they Load"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.percentLoan
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.points"
                  label="Points"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender?.points
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.interest"
                  label="Interest"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.interest
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.miscExpenses"
                  label="Misc. Expenses"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.miscExpenses
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.prepaymentPenalty"
                  label="Pre-payment Penalty"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.prepaymentPenalty
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.drawFees"
                  label="Draw Fees"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.drawFees
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.reimburseConstructionCosts"
                  label="Reimburse or Advance Construction Costs"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.reimburseConstructionCosts
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.timeFrameForDraw"
                  label="Time Frame for Draw Request"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.timeFrameForDraw
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.term"
                  label="Term"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender?.term
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.costExtension"
                  label="Cost of Extension"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.costExtension
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.pullCredit"
                  label="Pull Credit"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.pullCredit
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.minCreditScore"
                  label="Minimum Credit Score"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.minCreditScore
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.infoRequired"
                  label="Info Requuired"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.infoRequired
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.daysToClose"
                  label="How Many Days to Close"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.daysToClose
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLender.dateOfContact"
                  label="Date of Contact"
                  fullWidth
                  value={
                    formData?.optionalFields?.hardMoneyLender
                      ?.dateOfContact
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  I want to talk to someone about Hard Money Lending
                  for Fix & Flips. I went to your website, but still
                  have a few questions (Excellent Credit, 1st Flip,
                  Enough liquid funds to cover whatever is needed
                  [100k+])
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.fixFlip"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.fixFlip
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>What areas do you lend in?</Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.areas"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.areas
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Do you lend on % of ARV? Or % of Purchase Price and
                  Rehab? Or Purchase Price only?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.percentOf"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.percentOf
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  What are your Interest % Rates?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.interest"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.interest
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  What do you charge for Points? (aka ORIGINATION
                  FEES)
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.points"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.points
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Besides points and normal closing costs, what
                  additional closing costs should we expect, whether
                  from you or third party? (aka JUNK FEES)
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.junkFee"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.junkFee
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Is there a pre-payment penalty?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.prePayPenalty"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.prePayPenalty
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Are there draw fees and if so how much? (aka
                  INSPECTION FEES)
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.inspectionFee"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.inspectionFee
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Term - How Long is the loan for?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.term"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.term
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  *If 6 months or less, what is the cost of extension?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.extensionCost"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.extensionCost
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Do you advance or reimburse the construction costs?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.constructionCost"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.constructionCost
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  What is the typical timeframe before draw request to
                  payment?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.drawTime"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.drawTime
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Do you pull credit? (How important is credit or are
                  you more interested in the deal?)
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.pullCredit"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.pullCredit
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  What is your minimum credit score requirement? (if
                  applicable)
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.minimumCreditScore"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire
                      ?.minimumCreditScore
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  What info is required to make a decision on a deal?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.dealInfo"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.dealInfo
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  How many days does it take to close?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.timeToClose"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.timeToClose
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Are you a direct lender or are you a broker?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.lenderOrBroker"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.lenderOrBroker
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Can the funds come from a self directed IRA or a
                  solo 401k?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.retirementFund"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.retirementFund
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  *If yes, does this change any of the loan amounts,
                  interest rates, and points?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.retirementFundChanges"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire
                      ?.retirementFundChanges
                  }
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={12}>
                <Typography>
                  Can you email me what the next step is to get
                  started?
                </Typography>
              </Grid>
              <Grid size={12}>
                <TextField
                  name="optionalFields.hardMoneyLenderQuestionnaire.nextStepEmail"
                  fullWidth
                  multiline
                  rows={3}
                  value={
                    formData.optionalFields
                      ?.hardMoneyLenderQuestionnaire?.nextStepEmail
                  }
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {contact ? 'Update Contact' : 'Save Contact'}
            </Button>
          </DialogActions>
        </form>
      </BlockUi>
    </Dialog>
  )
}

export default HardMoneyLenderQuestions
